<template>
  <div class="storyline-guide">
    <div class="storyline-header">
      <div>
        <div class="storyline-kicker">终端优先演示</div>
        <h2>Rock5A 多模态终端协同故事线</h2>
        <p>先让评委看见终端、手势和语音，再由终端进入古贤数字孪生业务闭环。</p>
      </div>
      <button class="storyline-close" @click="$emit('close')">×</button>
    </div>

    <section class="terminal-story">
      <div class="terminal-story-copy">
        <span class="terminal-chip">比赛主叙事</span>
        <strong>不是“在平台里加了手势”，而是“终端用手势和语音驱动平台”</strong>
        <p>Rock5A 完成本地视觉识别、音频采集和交互仲裁；前端负责业务呈现。断网或链路异常会显示真实状态，不再假装在线。</p>
        <button @click="$emit('openModule', 'terminal')">查看实时终端状态</button>
      </div>
      <div class="terminal-flow">
        <div><b>01</b><strong>竖拇指</strong><span>明确激活手势控制</span></div>
        <i>→</i>
        <div><b>02</b><strong>捏合 / 握拳</strong><span>单击目标或唤醒语音</span></div>
        <i>→</i>
        <div><b>03</b><strong>语音协同</strong><span>查询并联动业务模型</span></div>
      </div>
    </section>

    <section class="story-section">
      <div class="section-title">
        <strong>推荐演示主线</strong>
        <span>终端唤醒 → 工程总览 → 洪水演进 → 预警预案</span>
      </div>
      <div class="primary-flow">
        <article v-for="(story, index) in primaryStories" :key="story.key" class="story-card primary">
          <span class="step-index">{{ index + 1 }}</span>
          <div class="story-card-top">
            <div>
              <h3>{{ story.title }}</h3>
              <p>{{ story.desc }}</p>
              <small>{{ story.opens }}</small>
            </div>
            <span :class="['story-status', story.statusClass]">{{ story.status }}</span>
          </div>
          <div class="story-progress">
            <span :style="{ width: story.progress + '%' }"></span>
          </div>
          <div class="story-meta">
            <span>{{ story.progress }}%</span>
            <button @click="$emit('openModule', story.module)">{{ story.action }}</button>
          </div>
        </article>
      </div>
    </section>

    <section class="story-section">
      <div class="section-title">
        <strong>支撑能力</strong>
        <span>按提问或汇报节奏随时切入</span>
      </div>
      <div class="support-grid">
        <article v-for="story in supportStories" :key="story.key" class="story-card">
          <div class="story-card-top">
            <div>
              <h3>{{ story.title }}</h3>
              <p>{{ story.desc }}</p>
              <small>{{ story.opens }}</small>
            </div>
            <span :class="['story-status', story.statusClass]">{{ story.status }}</span>
          </div>
          <div class="story-progress">
            <span :style="{ width: story.progress + '%' }"></span>
          </div>
          <div class="story-meta">
            <span>{{ story.progress }}%</span>
            <button @click="$emit('openModule', story.module)">{{ story.action }}</button>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
const primaryStories = [
  { key: 'overview', title: '工程总览', desc: '先交代枢纽规模、库容、水位和工程边界。', opens: '打开工程参数面板', action: '查看工程总览', module: 'reservoirInfo', progress: 80, status: '基本完成', statusClass: 'done' },
  { key: 'monitoring', title: '综合监控', desc: '再进入实时水情、雨情、水质和站点态势。', opens: '打开综合监控大屏', action: '查看综合监控', module: 'monitoring', progress: 78, status: '可演示', statusClass: 'done' },
  { key: 'flood', title: '洪水演进', desc: '重点展示频率切换、方案比选、龙门断面过程线。', opens: '打开洪水预演面板', action: '进入洪水演进', module: 'floodSim', progress: 86, status: '重点完成', statusClass: 'strong' },
  { key: 'emergency', title: '预警预案', desc: '承接预演结果，展示防汛预案、物资和队伍。', opens: '打开推荐应急预案', action: '联动预警预案', module: 'emergency', progress: 66, status: '补强中', statusClass: 'warn' },
]

const supportStories = [
  { key: 'dispatch', title: '水库调度', desc: '保守、均衡、泄洪优先方案对比与会商建议。', opens: '打开调度比选面板', action: '进入调度比选', module: 'custom', progress: 75, status: '可演示', statusClass: 'done' },
  { key: 'supply', title: '供需平衡', desc: '供水规模、分区缺口、缺水预警到调度建议。', opens: '打开供需平衡分析', action: '查看供需平衡', module: 'supplyDemand', progress: 70, status: '补强中', statusClass: 'warn' },
  { key: 'management', title: '业务管理', desc: '运行任务、工程进度、运维工单和通知公告。', opens: '打开运行调度任务', action: '查看业务管理', module: 'scheduling', progress: 72, status: '可演示', statusClass: 'done' },
  { key: 'assistant', title: 'AI交互', desc: '自然语言查数、开面板、联算模型和专家汇报。', opens: '打开知识问答面板', action: '打开AI问答', module: 'knowledgeQA', progress: 68, status: '持续优化', statusClass: 'warn' },
]

export default {
  name: 'StorylineGuide',
  data() {
    return {
      primaryStories,
      supportStories,
    }
  }
}
</script>

<style scoped>
.storyline-guide {
  width: 100%;
  height: 100%;
  padding: 18px;
  color: #eef7ff;
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border: 1px solid rgba(99, 179, 237, 0.28);
  border-radius: 10px;
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
  overflow: auto;
}

.storyline-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.storyline-kicker {
  color: #76d9ff;
  font-size: 12px;
  margin-bottom: 6px;
}

.storyline-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.storyline-header p {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, 0.64);
  font-size: 12px;
}

.storyline-close {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
}

.terminal-story {
  display: grid;
  grid-template-columns: minmax(260px, 0.9fr) minmax(420px, 1.5fr);
  align-items: center;
  gap: 18px;
  margin-bottom: 16px;
  padding: 15px;
  border: 1px solid rgba(52, 211, 153, 0.28);
  border-radius: 10px;
  background:
    radial-gradient(circle at 12% 25%, rgba(34, 211, 238, 0.14), transparent 38%),
    linear-gradient(135deg, rgba(6, 78, 59, 0.2), rgba(8, 47, 73, 0.16));
}

.terminal-story-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
}

.terminal-chip {
  padding: 3px 8px;
  border-radius: 999px;
  color: #a7f3d0;
  background: rgba(52, 211, 153, 0.13);
  font-size: 10px;
}

.terminal-story-copy strong { color: #ecfeff; font-size: 14px; line-height: 1.5; }
.terminal-story-copy p {
  margin: 0;
  color: rgba(236, 254, 255, 0.62);
  font-size: 11px;
  line-height: 1.65;
}
.terminal-story-copy button {
  margin-top: 2px;
  padding: 6px 11px;
  border: 1px solid rgba(103, 232, 249, 0.32);
  border-radius: 7px;
  color: #a5f3fc;
  background: rgba(34, 211, 238, 0.1);
  cursor: pointer;
}

.terminal-flow {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  align-items: center;
  gap: 8px;
}
.terminal-flow > div {
  min-height: 88px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  border: 1px solid rgba(103, 232, 249, 0.16);
  border-radius: 9px;
  background: rgba(8, 47, 73, 0.22);
}
.terminal-flow b { color: rgba(103, 232, 249, 0.56); font-size: 10px; }
.terminal-flow strong { color: #ecfeff; font-size: 13px; }
.terminal-flow span { color: rgba(236, 254, 255, 0.52); font-size: 10px; }
.terminal-flow i { color: rgba(103, 232, 249, 0.5); font-style: normal; }

.story-section + .story-section {
  margin-top: 16px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.section-title strong {
  color: #fff;
  font-size: 14px;
}

.section-title span {
  color: rgba(255, 255, 255, 0.52);
  font-size: 12px;
  text-align: right;
}

.primary-flow {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.support-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.story-card {
  position: relative;
  min-height: 154px;
  padding: 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.story-card.primary {
  padding-top: 34px;
  border-color: rgba(56, 189, 248, 0.18);
  background: rgba(56, 189, 248, 0.055);
}

.step-index {
  position: absolute;
  top: 10px;
  left: 12px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(56, 189, 248, 0.18);
  border: 1px solid rgba(56, 189, 248, 0.34);
  color: #b8ecff;
  font-size: 12px;
}

.story-card-top {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.story-card h3 {
  margin: 0 0 7px;
  font-size: 15px;
}

.story-card p {
  margin: 0;
  min-height: 40px;
  color: rgba(255, 255, 255, 0.66);
  font-size: 12px;
  line-height: 1.55;
}

.story-card small {
  display: block;
  margin-top: 7px;
  color: rgba(125, 211, 252, 0.76);
  font-size: 11px;
}

.story-status {
  flex: 0 0 auto;
  height: 22px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  white-space: nowrap;
}

.story-status.done { color: #67e8f9; background: rgba(103, 232, 249, 0.12); }
.story-status.strong { color: #86efac; background: rgba(134, 239, 172, 0.14); }
.story-status.warn { color: #facc15; background: rgba(250, 204, 21, 0.12); }

.story-progress {
  height: 5px;
  margin: 14px 0 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.story-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #38bdf8, #34d399);
}

.story-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.58);
  font-size: 12px;
}

.story-meta button {
  height: 28px;
  padding: 0 12px;
  border-radius: 7px;
  border: 1px solid rgba(56, 189, 248, 0.32);
  background: rgba(56, 189, 248, 0.12);
  color: #b8ecff;
  cursor: pointer;
  white-space: nowrap;
}

.story-meta button:hover {
  background: rgba(56, 189, 248, 0.22);
}

@media (max-width: 1280px) {
  .terminal-story { grid-template-columns: 1fr; }
  .primary-flow,
  .support-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .terminal-flow { grid-template-columns: 1fr; }
  .terminal-flow i { display: none; }
  .primary-flow,
  .support-grid,
  .section-title {
    grid-template-columns: 1fr;
  }

  .section-title {
    display: block;
  }

  .section-title span {
    display: block;
    margin-top: 5px;
    text-align: left;
  }
}
</style>
